import { number, bool } from 'prop-types';
import { promoCodeType } from '../DiscountPromoCodeNotice/propTypes';

export const RangesPromoCodeDiscountNoticeType = {
    ...promoCodeType,
    orderValue: number,
    showPercentageDiscount: bool
};
